<template>
  <div
    v-bind:class="{
      'hot-game-push': true,
      'ani-time': aniTime,
      loaded: loaded,
      expand: expand,
    }"
    ref="hotGamePush"
    v-bind:style="{ transform: wrapperX, width: wrapperWidth }"
  >
    <v-mask
      v-show="expand"
      style="background: none"
      @touchmove="gtouchmove"
      @click="handleToggle"
    ></v-mask>
    <div ref="menuList" class="menu-list">
      <img
        ref="menuBgImg"
        src="@/assets/img/hot-game-push/UI_RMYX_BG_01.png"
        ondragstart="return false;"
        @touchmove="gtouchmove"
        v-if="style == 1"
      />
      <img
        ref="menuBgImg"
        src="@/assets/style2/img/hot-game-push/UI_yqrmyx_bg.png"
        ondragstart="return false;"
        @touchmove="gtouchmove"
        v-else
      />
      <div class="game-list" v-bind:style="gameListStyle" ref="gameList">
        <div class="game-list-box">
          <scale-box
            v-for="(item, i) in gameList"
            v-bind:key="i"
            v-bind:style="imgBoxStyle"
            class="img-box"
            @click="handleJump(item)"
            v-preventReClick="2000"
            v-clickMusic
            :gamePic="item.game_pic"
          ></scale-box>
        </div>
      </div>
    </div>
    <div
      v-bind:class="{
        toggle: style == 1,
        'toggle-style2': style != 1,
        'toggle-status1': !expand,
        'toggle-status2': expand,
      }"
      @click="handleToggle"
      v-clickMusic
      v-bind:style="{ left: x + 'px', transform: toggleLeft, top: toggleTop }"
    ></div>
  </div>
</template>

<script>
import { jumpGameByGameID, reportUserBehavior } from "@/logic/src/common";
import vmask from "@/components/mask.vue";
import scaleBox from "./scaleBox.vue";
import BScroll from "@better-scroll/core";
import store from "@/store/index";
import { getHotGamePush } from "@/api/task";
export default {
  name: "dialogNotice",
  components: {
    "v-mask": vmask,
    scaleBox,
  },
  data() {
    return {
      style: store.state.app.appInfo.style,
      gameID: 0,
      gameList: [],
      x: 0,
      toggleLeft: "translateX(0px)",
      toggleTop: "0.85rem",
      wrapperX: "translateX(0px)",
      wrapperWidth: "auto",
      expand: false,
      aniTime: false,
      gameListStyle: {
        top: "0.22rem",
        right: "0.07rem",
        bottom: "0.07rem",
      },
      imgBoxStyle: {
        width: "1.05rem",
        height: "0.65rem",
      },
      gameListScroller: null,
      loaded: false,
    };
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
    areaSize() {
      return store.state.app.areaSize;
    },
    platform() {
      return store.state.app.platform;
    },
    toggleLeftValue() {
      if (this.style == 1) {
        return 0.06;
      } else {
        return 0.03;
      }
    },
  },
  mounted() {
    this.setGameListScroller();
    this.$refs.menuBgImg.addEventListener("load", () => {
      this.$nextTick(() => {
        this.resetBtnX();
        this.resetToggleX();
        this.getData();
      });
    });
  },
  watch: {
    closeAllPopUp(val) {
      if (this.expand && val.key != "hotGamePush") {
        this.handleToggle();
      }
    },
    areaSize() {
      this.aniTime = false;
      this.$nextTick(() => {
        this.resetBtnX();
        this.resetToggleX();
      });
    },
    expand() {
      this.$nextTick(() => {
        this.resetToggleX();
        this.resetBtnX();
      });
    },
  },
  methods: {
    //获取数据
    getData() {
      getHotGamePush({
        game_id: this.gameID,
        identity: store.state.app.appInfo.identity,
      }).then((res) => {
        res = res.data;
        if (res.code == 0 && res.result.data.length > 0) {
          this.gameList = res.result.data;
          this.loaded = true;
          this.$nextTick(() => {
            if (this.gameListScroller != null) {
              this.gameListScroller.refresh();
            }
          });
        } else {
          if (window._hotGamePush != null) {
            window._hotGamePush.close();
            window._hotGamePush = null;
          }
        }
      });
    },
    //设置滚动区域
    setGameListScroller() {
      if (this.gameListScroller != null) {
        this.gameListScroller.destroy();
        this.gameListScroller = null;
      }
      this.gameListScroller = new BScroll(this.$refs.gameList, {
        click: true,
      });
    },
    //重新设置toggle的位置
    resetToggleX() {
      if (this.expand) {
        this.wrapperX = "translateX(0px)";
        this.wrapperWidth = "100%";
      } else {
        this.wrapperX = `translateX(-${this.x}px)`;
        this.wrapperWidth = "auto";
      }
    },
    //重新设置btn的位置
    resetBtnX() {
      if (this.$refs.menuBgImg) {
        this.x = window
          .getComputedStyle(this.$refs.menuBgImg, null)
          .width.split("px")[0];
        this.resetScaleSize();
      }
    },
    //重置适配尺寸
    resetScaleSize() {
      const h = window.document.documentElement.getBoundingClientRect().height;
      const scale = h / 720;
      if (this.expand) {
        if (h > 720) {
          this.toggleLeft = `translateX(${-this.toggleLeftValue * scale}rem)`;
          this.gameListStyle = {
            top: `${0.22 * scale}rem`,
            right: `${0.07 * scale}rem`,
            bottom: `${0.07 * scale}rem`,
          };
          this.imgBoxStyle = {
            width: `${1.05 * scale}rem`,
            height: `${0.65 * scale}rem`,
          };
          this.toggleTop = `${0.85 * scale}rem`;
        } else {
          this.toggleLeft = `translateX(-${this.toggleLeftValue}rem)`;
          this.gameListStyle = {
            top: "0.22rem",
            right: "0.07rem",
            bottom: "0.07rem",
          };
          this.imgBoxStyle = {
            width: "1.05rem",
            height: "0.65rem",
          };
          this.toggleTop = "0.85rem";
        }
        this.$nextTick(() => {
          if (this.gameListScroller != null) {
            this.gameListScroller.refresh();
          }
        });
      } else {
        this.toggleLeft = "translateX(0px)";
        if (h > 720) {
          this.toggleTop = `${0.85 * scale}rem`;
        } else {
          this.toggleTop = "0.85rem";
        }
      }
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    handleToggle() {
      this.aniTime = true;
      this.$nextTick(() => {
        this.expand = !this.expand;
        if (this.expand) {
          store.dispatch("setCloseAllPopUp", "hotGamePush");
        }
      });
    },
    reset() {
      this.expand = false;
      this.$nextTick(() => {
        this.remove();
      });
    },
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
    handleJump(item) {
      const gameId = item.game_id;
      this.handleToggle();
      //行为上报
      reportUserBehavior(this.gameID, 0, 8004, gameId);
      jumpGameByGameID(gameId);
      // //web
      // if (this.platform == 0) {
      //   ifmTool.closeGame();
      //   store.dispatch("setOpenGameID", gameId);
      // }
      // //app
      // else {
      //   initApp(gameId, true).then((res) => {
      //     window.nativeUtils.getGameInfo(gameId).then((e) => {
      //       if (e) {
      //         const gameInfo = JSON.parse(e);
      //         if (gameInfo.version) {
      //           if (
      //             parseInt(String(gameInfo.version).split(".").join("")) ==
      //             parseInt(String(res.version).split(".").join(""))
      //           ) {
      //             store.dispatch("setOpenGameUrl", gameInfo.native_url);
      //             ifmTool.closeGame();
      //           } else {
      //             this.$toast("这个游戏还没有更新，请返回大厅进行更新");
      //           }
      //         } else {
      //           this.$toast("这个游戏还没有下载，请返回大厅进行下载");
      //         }
      //       } else {
      //         this.$toast("这个游戏还没有下载，请返回大厅进行下载");
      //       }
      //     });
      //   });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.hot-game-push {
  position: fixed;
  display: block;
  z-index: 10000;
  visibility: hidden;
  left: 0;
  top: 0;
  height: 100%;
  &.expand {
    z-index: 10001;
  }
  &.loaded {
    visibility: visible;
  }
  &.ani-time {
    transition-duration: 0.2s;
  }
  .menu-list {
    position: absolute;
    z-index: 99999;
    top: 0;
    left: 0;
    height: 100%;
    img {
      height: 100%;
      display: block;
    }
    .game-list {
      position: absolute;
      display: block;
      left: 0;
      overflow: hidden;
      .game-list-box {
        .img-box {
          width: 1.05rem;
          height: 0.65rem;
          display: block;
          margin: 0 auto;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .toggle {
    position: absolute;
    width: 0.26rem;
    height: 0.915rem;
    display: block;
    z-index: 99999;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &.toggle-status1 {
      background: url(~@/assets/img/hot-game-push/UI_RMYX_biaoqian_01.png)
        no-repeat;
      background-size: contain;
    }
    &.toggle-status2 {
      background: url(~@/assets/img/hot-game-push/UI_RMYX_biaoqian_02.png)
        no-repeat;
      background-size: contain;
    }
  }

  .toggle-style2 {
    position: absolute;
    width: 0.26rem;
    height: 0.915rem;
    display: block;
    z-index: 99999;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &.toggle-status1 {
      background: url(~@/assets/style2/img/hot-game-push/UI_RMYX_biaoqian_01.png)
        no-repeat;
      background-size: contain;
    }
    &.toggle-status2 {
      background: url(~@/assets/style2/img/hot-game-push/UI_RMYX_biaoqian_02.png)
        no-repeat;
      background-size: contain;
    }
  }
}
</style>